// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Icon';
export * from './Icon';



// WEBPACK FOOTER //
// ./components/Icon/index.js